const styles = {
  root: {
    '& .green-progress': {
      color: '#38AC3D !important',
    },
    '& .red-progress': {
      color: '#FD6969 !important',
    },
    '& .bg-progress': {
      color: '#E5E5E5 !important',
    },
  },
};

export default styles;
